import { useState } from 'react'
import styled from '@emotion/styled'

import useOrder from 'modules/order/state/order/use-order'
import useDrawer from 'modules/drawer/state/use-drawer'
import DrawerPanel from 'modules/drawer/components/drawer-panel/drawer-panel'
import { TextArea } from 'modules/ui/atoms/TextArea'
import { DEFAULT_THEME_COLORS } from 'css/theme'
import useConfig from 'modules/config/state/use-config'
import { focusOnElement } from 'modules/drawer/components/drawer/drawer.utils'
import { ORDER_COMMENT_DRAWER_OPENER_DATA_ID } from './order-comment-drawer-opener'
import { useTranslation } from 'next-i18next'

const MAX_COMMENT_LENGTH = 1000

const OrderCommentDrawerPanel = () => {
  const { t } = useTranslation()
  const drawer = useDrawer({ onClose: focusOnElement(ORDER_COMMENT_DRAWER_OPENER_DATA_ID) })
  const order = useOrder()
  const config = useConfig()

  const [draft, setDraft] = useState(order.comment.value)

  if (!drawer.current) {
    return null
  }

  const isContentPanelNull = config.contentPanel == null

  return (
    <DrawerPanel title={drawer.current.label} closeButtonDataId="comment-drawer-close-button">
      <DrawerPanel.Body>
        <TextAreaWrapper>
          <TextArea
            tabIndex={0}
            value={draft}
            maxLength={MAX_COMMENT_LENGTH}
            onChange={setDraft}
            dataId="comment-drawer-textarea"
            autoFocus
          />
        </TextAreaWrapper>
      </DrawerPanel.Body>

      <DrawerPanel.Footer isMobileView={isContentPanelNull}>
        <DrawerPanel.FooterAction
          onClick={drawer.close}
          data-id="comment-drawer-cancel-button"
          isMobileView={isContentPanelNull}
        >
          {t('orderCommentDrawerPanel.footer.cancel', 'Cancel')}
        </DrawerPanel.FooterAction>
        <DrawerPanel.FooterAction
          onClick={() => {
            drawer.close()
            order.comment.setValue(draft)
          }}
          disabled={draft.length > MAX_COMMENT_LENGTH}
          data-id="comment-drawer-save-button"
          color={DEFAULT_THEME_COLORS['--theme-color--neutral-20']}
          isMobileView={isContentPanelNull}
        >
          {t('orderCommentDrawerPanel.footer.save', 'Save')}
        </DrawerPanel.FooterAction>
      </DrawerPanel.Footer>
    </DrawerPanel>
  )
}

export default OrderCommentDrawerPanel

const TextAreaWrapper = styled.div`
  textarea {
    height: 420px;
  }
`
